import { DROPDOWN_ITEM_ID_ATTRIBUTE } from './dropdown.constants';
const getNameWords = (value) => { var _a; return (_a = value === null || value === void 0 ? void 0 : value.trim().split(/\s+/).filter(Boolean)) !== null && _a !== void 0 ? _a : []; };
export const getAvatarInitials = (user) => {
    const firstWords = getNameWords(user === null || user === void 0 ? void 0 : user.first);
    const lastWords = getNameWords(user === null || user === void 0 ? void 0 : user.last);
    if (firstWords.length && lastWords.length) {
        const [first] = firstWords;
        const [last] = lastWords;
        return `${first[0]}${last[0]}`.toUpperCase();
    }
    const singleNameWords = firstWords.length > 0 ? firstWords : lastWords;
    const initials = singleNameWords
        .slice(0, 2)
        .map((word) => word[0])
        .join('');
    return initials ? initials.toUpperCase() : undefined;
};
const getOptionElements = (container) => Array.from(container.querySelectorAll('[role="menuitem"]'));
/**
 * The option the user is currently on. Headless UI focuses the active option, and falls back to its own state
 * attribute for the frames where focus has not landed yet.
 */
export const getActiveOptionId = (container) => {
    var _a, _b;
    const options = getOptionElements(container);
    const activeOption = (_a = options.find((option) => option.contains(document.activeElement))) !== null && _a !== void 0 ? _a : options.find((option) => { var _a; return (_a = option.getAttribute('data-headlessui-state')) === null || _a === void 0 ? void 0 : _a.split(' ').includes('active'); });
    return (_b = activeOption === null || activeOption === void 0 ? void 0 : activeOption.getAttribute(DROPDOWN_ITEM_ID_ATTRIBUTE)) !== null && _b !== void 0 ? _b : undefined;
};
/**
 * Moves focus onto `itemId`, or onto the first option the user can act on when it is not available. Keeps drilling in
 * and stepping back from stranding focus on the menu container.
 */
export const focusOption = (container, itemId) => {
    const options = getOptionElements(container);
    const target = (itemId && options.find((option) => option.getAttribute(DROPDOWN_ITEM_ID_ATTRIBUTE) === itemId)) ||
        options.find((option) => option.getAttribute('aria-disabled') !== 'true');
    target === null || target === void 0 ? void 0 : target.focus();
};
//# sourceMappingURL=dropdown.utils.js.map